// Which review action (if any) a keypress on the agent-run page should trigger.
//
// Approving an AI run can send email to a customer or close a ticket, so a single-letter shortcut
// must never fire by accident. The page's old handler only ignored INPUT/TEXTAREA/contentEditable,
// so Ctrl/Cmd+A ("select all", e.g. to copy the AI's draft) approved the run and Ctrl/Cmd+R
// (reload) rejected it, both with preventDefault swallowing the browser's own action; typing in a
// <select>, or holding the key down, fired it as well.
export function reviewShortcutAction(e) {
  if (e.ctrlKey || e.metaKey || e.altKey || e.repeat) return null;
  const target = e.target;
  const tag = target?.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target?.isContentEditable) return null;
  if (e.key === "a" || e.key === "A") return "approve";
  if (e.key === "r" || e.key === "R") return "reject";
  return null;
}
